export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7338.c5e71e2a.jpg";